import React from 'react';
import { style, types } from 'typestyle';

export { classes } from 'typestyle';

export type Style = types.NestedCSSProperties;

/** Creates a unique classname for the specified styles using TypeStyle */
export function cssClass(prefix: string, name: string, ...styles: Style[]): string {
  return style(...styles, {
    $debugName: `${prefix}_${name}`,
    $unique: true,
  });
}

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OtherDivProps = Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'className'>;

export const errorNameContainsSpaces = 'DivWithStyle component name may not contain spaces';

export function divWithStyle(prefix: string, name: string, styles: Style | Style[], definedDivProps?: OtherDivProps):
React.ComponentType<OtherDivProps> {

  if (name.indexOf(' ') > -1) {
    throw new Error(errorNameContainsSpaces);
  }

  if (!Array.isArray(styles)) {
    styles = [styles];
  }

  const className = cssClass(prefix, name, ...styles);

  return class extends React.Component<OtherDivProps> {
    public static displayName: string = name;

    public render() {
      const divPropsWithClassName = { ...definedDivProps, ...this.props, className };
      return (
        <div {...divPropsWithClassName}>
          {this.props.children}
        </div>
      );
    }
  };
}

export const fillStyle: Style = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
};

export const boxStyle: Style = {
  display: 'inline-block',
  verticalAlign: 'top',
};

export const flexColumnStyle: Style = {
  display: 'flex',
  flexDirection: 'column',
};

export const flexRowStyle: Style = {
  display: 'flex',
  flexDirection: 'row',
};

export const textEllipsis: Style = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

export const baseBackgroundImgIcon: Style = {
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
};
